import React from 'react';
import { useHotel } from '../context/HotelContext';
import { HOTELS_IMAGE_ROOT_URL, OUTELETS_IMAGE_ROOT_URL } from '../constant';
import { useNavigate } from 'react-router-dom';

const OuteletList = () => {
    const { hotelDetails } = useHotel();
    const navigate = useNavigate();
    const outeletClickHandler = (outletID) => {
        navigate(`/home?outletID=${outletID}`);
    };
    console.log(hotelDetails);
    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-start items-center pb-4'>
            <div className='head-section w-full z-10 flex justify-center items-center flex-row  py-3 relative md:justify-center md:flex-col md:py-5'>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-32 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
            </div>
            <div className='outelet-container w-full flex flex-col gap-4 mt-2 px-0 md:mt-10 md:px-4'>
                {hotelDetails.outlets?.map((item) => (
                    <OuteletCard
                        key={item.id}
                        {...item}
                        outeletClickHandler={() => outeletClickHandler(item.id)}
                    />
                ))}
            </div>
        </div>
    );
};

export default OuteletList;

const OuteletCard = (props) => {
    const { banner, name, outeletClickHandler } = props;
    return (
        <div
            class='outelet-card '
            onClick={outeletClickHandler}
            style={{
                backgroundImage: `url(${OUTELETS_IMAGE_ROOT_URL}${encodeURIComponent(
                    banner
                )})`,
            }}
        >
            <div class='outelet-title'>{name}</div>
        </div>
    );
};
